import React from 'react';
import TestiBox from './TestiBox';
import { useTranslation } from 'react-i18next';

const TestiSecThree = ({ className }) => {

    const { t } = useTranslation();

    return (
    <section className={className}>
        <div
            className="shape-mockup bg-gradient-shape1"
            data-top="10%"
            data-left="3%"
        />
        <div
            className="shape-mockup bg-gradient-shape1"
            data-top="auto"
            data-left="auto"
            data-bottom="10%"
            data-right="3%"
        />

        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="title-area text-center">
                        <span className="sub-title style2" data-cue="slideInUp">{t('sections.testimonialSecOne.sub_title','Testimonial')}</span>
                        <h2 className="sec-title" data-cue="slideInUp">{t('sections.testimonialSecOne.title','What Our Customers Say')}</h2>
                    </div>
                </div>
            </div>
            <div className="row gy-4" data-cues="slideInUp" data-group="testi-box">
                <TestiBox className="col-lg-4 col-md-6" limit={6} />
            </div>
        </div>
    </section>
  );
};

export default TestiSecThree;